import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UiDateRangeQuickHeaderComponent } from './date-range-quick-header.component';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatIconModule],
    declarations: [UiDateRangeQuickHeaderComponent],
    exports: [UiDateRangeQuickHeaderComponent],
})
export class UiDateRangeQuickHeaderModule {}

